import React from "react";
import { Moon } from "lucide-react";

export default function RamadanBanner({ settings }) {
  if (!settings?.ramadan_mode_enabled) return null;

  const hours =
    settings.ramadan_opening_time && settings.ramadan_closing_time
      ? `${settings.ramadan_opening_time} – ${settings.ramadan_closing_time}`
      : null;

  return (
    <div className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-950 mb-3">
      <Moon className="h-4 w-4 mt-0.5 shrink-0" />
      <div className="text-[12px] leading-snug">
        <span className="font-semibold">Ramadan mode</span>
        {hours ? <span className="text-amber-800"> · Hours {hours}</span> : null}
        {settings.ramadan_message ? (
          <p className="text-amber-900 mt-0.5">{settings.ramadan_message}</p>
        ) : null}
        {settings.ramadan_preorder_only ? (
          <p className="text-[11px] text-amber-800 mt-1">Pre-order menu only during fasting hours.</p>
        ) : null}
      </div>
    </div>
  );
}
